var path = '/templates/projects.campaigns/views/directives/campaign_range.html';
var html = "<span><span ng-if=campaign.start_at>{{ campaign.start_at | zcDate: { smart: true, dateOnly: dateOnly } }}</span> <span ng-if=!campaign.start_at>{{ 'projectsCampaignsViews.directives.campaignRange.misetsu_kyoutei' | translate }}</span><br>~ <span ng-if=campaign.end_at>{{ campaign.is_infinite ? ('projectsCampaignsViews.directives.campaignRange.kigen_nashi' | translate) : (campaign.end_at | zcDate: { smart: true, dateOnly: dateOnly }) }}</span> <span ng-if=!campaign.end_at>{{ 'projectsCampaignsViews.directives.campaignRange.misetsu_kyoutei' | translate }}</span></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.campaigns/views/directives/campaign_range.html
// module id = 1428
// module chunks = 0